var classof = require('../internals/classof-raw');

module.exports = typeof process != 'undefined' && classof(process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/engine-is-node.js
// module id = 74
// module chunks = 0